import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Alert } from 'antd';
import auth from '../auth';

class StickyNotesContainer extends Component {
    constructor(props) {
        super(props);
        this.redirect = this.redirect.bind(this);
    }

    render() {
        let { stickyNotes, licenseStatus } = this.props;
        if(!auth.isAuthenticated())
            return null;
        return (
            <React.Fragment>
            {
                <div className="container sticky-note-container">
                    { 
                        licenseStatus === false &&
                        <Alert 
                            message={ 
                                        <div> 
                                            Actualmente no cuentas con una licencia vigente.
                                        </div>
                                    }
                            type="warning" 
                            showIcon
                            style={styles.alert}
                        /> 
                    }
                {
                    stickyNotes && stickyNotes.length > 0 &&
                    stickyNotes.map(stickyNote => {
                        return (
                            <Alert 
                                key={stickyNote.id }
                                message={stickyNote.message }
                                type= {stickyNote.alertType} 
                                showIcon
                                style={styles.alert}
                            />
                        );
                    })
                }
                </div>
            }
            </React.Fragment>
        );
    }

    redirect() {
        this.props.history.push(`/buy-license/user/${this.props.values.username}`);
    }
}

const styles = {
    alert: { marginBottom: '10px' },
}

const mapStateToProps = state => {
    return {
        stickyNotes: state._genericComponents.stickyNotes.items,
        licenseStatus: state.license.licenseStatus.isValid,
        values: state.login.login.values,
    }
}

export default connect(mapStateToProps, null)(withRouter(StickyNotesContainer));